import {
  UserSystemResponse,
} from "services/interface";
import styled from "@emotion/styled";
import { Col, Row, message } from "antd";
import { Dispatch, FC, SetStateAction } from "react";
import TableUserSystem from "./TableUserSystem";
import { useDeleteUserSystem } from "hooks/useAuth";
import { useQueryClient } from "@tanstack/react-query";

interface UserSystemListProps {
  data: UserSystemResponse | undefined;
  refetch: () => void;
  limit: number;
  offset: number;
  setLimit: Dispatch<SetStateAction<number>>;
  setOffset: Dispatch<SetStateAction<number>>;
}

const UserSystemList: FC<UserSystemListProps> = ({
  data,
  refetch,
  limit,
  offset,
  setLimit,
  setOffset,
}) => {
  const { mutate: DeleteUserDelete, isPending: deleteLoading } =
    useDeleteUserSystem();

  const queryClient = useQueryClient();

  const onDeleteConfigs = (id: string) => {
    DeleteUserDelete(
      {
        id: id,
      },
      {
        onSuccess: async (res) => {
          if (!res.error_message) {
            await queryClient.refetchQueries({
              queryKey: ["user_system"],
              type: "active",
            });
            message.success("ลบสำเร็จ");
            refetch();
          } else {
            message.error(`ลบไม่สำเร็จ: ${res.error_message}`);
          }
        },
        onError: (error) => {
          message.error(`ลบไม่สำเร็จ: ${error.message}`);
        },
      }
    );
  };

  return (
    <WrapperAll>
      <Row
        gutter={[16, 16]}
        style={{ backgroundColor: "#EFEFEF", overflow: "auto" }}
      >
        <Col span={24}>
          <CardWrapperTable>
            <TableUserSystem
              data={data?.factories}
              onDeleteConfigs={onDeleteConfigs}
              limit={limit}
              offset={offset}
              setLimit={setLimit}
              setOffset={setOffset}
              total={data?.total_record}
            />
          </CardWrapperTable>
        </Col>
      </Row>
    </WrapperAll>
  );
};

export default UserSystemList;
const WrapperAll = styled.div`
  padding: 0px 0px 10px 0px;
  background-color: #efefef;
`;

const CardWrapperTable = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  background-color: #ffffff;
  padding: 5px;
`;
